import * as THREE from "three";
import { CSS3DRenderer } from "three/examples/jsm/renderers/CSS3DRenderer";
import Experience from "./Experience";

// A second render pass alongside the WebGL one, for DOM/CSS content that
// needs to sit in the same 3D scene (position/rotation/scale tracking the
// same camera and corner-pin basis as everything else) but is real HTML —
// currently only the "Video Text" card (see VideoTextDom), which is a rich
// UI composition (heading, video, play button, paragraph) better built in
// CSS than rasterized to a canvas texture.
//
// This is a genuinely separate DOM layer stacked on top of the WebGL
// canvas via CSS 3D transforms — it does NOT pass through the WebGL
// composer's post-processing (FXAA/grading/vignette), a deliberate choice
// (see conversation): the card reads as a clean UI element, not baked into
// the cinematic film grade, matching how the Figma design actually looks.
export default class Css3dRenderer {
  constructor() {
    this.experience = new Experience();
    this.sizes = this.experience.sizes;
    this.camera = this.experience.camera;

    this.setInstance();
  }

  setInstance() {
    this.instance = new CSS3DRenderer();
    this.instance.setSize(this.sizes.width, this.sizes.height);

    Object.assign(this.instance.domElement.style, {
      position: "fixed",
      top: "0",
      left: "0",
      // Explicit, not just relying on DOM insertion order — always paints
      // above the WebGL canvas regardless of source order elsewhere.
      zIndex: "5",
      // Lets pointer events (wheel/touch scroll navigation, mouse-tracked
      // tilt) fall through to the WebGL canvas underneath by default; the
      // card's own DOM re-enables it locally for the play button.
      pointerEvents: "none",
    });

    document.body.appendChild(this.instance.domElement);

    this.scene = new THREE.Scene();
  }

  resize() {
    this.instance.setSize(this.sizes.width, this.sizes.height);
  }

  update() {
    this.instance.render(this.scene, this.camera.instance);
  }
}
